"use strict";var test={__proto__:null,foo:{}},$Object=Object;module.exports=function(){return{__proto__:test}.foo===test.foo&&!(test instanceof $Object)};